var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgRoad = function SvgRoad(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 68,
    viewBox: "0 0 95 68",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-stadt-verkehrsplaner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, desc === undefined ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, "Created with Sketch.") : desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#183E62",
    strokeWidth: 2,
    d: "m93.546 59.209-22.57-55C70.174 2.253 68.426 1 66.501 1H50.744l.396 3.98c.08.812-.519 1.52-1.286 1.52h-4.708c-.767 0-1.366-.708-1.285-1.52L44.257 1H28.5c-1.926 0-3.675 1.253-4.477 3.209l-22.57 55C-.041 62.85 2.343 67 5.932 67h31.78l1.665-16.789c.14-1.399 1.247-2.461 2.57-2.461h11.108c1.322 0 2.43 1.062 2.568 2.461L57.288 67h31.781c3.59 0 5.972-4.15 4.477-7.791ZM43.794 12.23c.073-.7.659-1.231 1.357-1.231h6.697c.697 0 1.283.531 1.356 1.23l.784 7.49c.128 1.22-.82 2.28-2.033 2.28h-6.91a2.055 2.055 0 0 1-2.033-2.28zM51.434 43h-8.868c-1.523 0-2.712-1.44-2.551-3.094l.813-8.4C40.966 30.082 42.066 29 43.379 29h7.242c1.313 0 2.413 1.082 2.551 2.506l.813 8.4C54.145 41.56 52.957 43 51.434 43Z"
  })));
};
export default SvgRoad;